/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".footpad[_ngcontent-%COMP%]{padding-left:68px}small.ftrcpyrght[_ngcontent-%COMP%]{color:#fff!important;font-size:18px}"];
export { styles as styles };

